/**
 * LeadSources route entry.
 *
 * Keeps /lead-sources as the dedicated source management/config page.
 * Growth Channels still has the performance cockpit sources lens, but source
 * configuration needs a stable edit surface that does not redirect away.
 */
import LeadSourceManagement from "./LeadSourceManagement";

export default function LeadSources() {
  return <LeadSourceManagement />;
}
